module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya/access/nagoya_point1_2-3a8f3fae0e19a62235649901fee00105.jpg";